import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: [],
  isLoaded: false,
  isBulkActionLoading: false,
  page: 1,
  pageCount: 1,
  total: 0,
  perPage: 50,
  search: '',
  network: '',
  programStatus: '',
  approvalStatus: '',
  sort: '',
  activeTab: 'game',
  selectedRowKeys: [],
  networks: [],
  gameGenres: [],
  programDetail: null,
  isProgramLoading: false,
  isProgramSaving: false,
  goalDetail: null,
  isGoalLoading: false,
  isGoalSaving: false,
  isFeatureSaving: false,
}

const earnOffersManagementSlice = createSlice({
  name: 'earnOffersManagement',
  initialState,
  reducers: {
    fetchOffersSuccess: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      data: payload.data,
      page: payload.page,
      pageCount: payload.pageCount,
      total: payload.total,
    }),
    fetchOffersFailure: (state) => ({
      ...state,
      isLoaded: true,
    }),
    setLoading: (state) => ({
      ...state,
      isLoaded: false,
    }),
    saveFilters: (state, { payload }) => ({
      ...state,
      search: payload.search ?? state.search,
      network: payload.network ?? state.network,
      programStatus: payload.programStatus ?? state.programStatus,
      approvalStatus: payload.approvalStatus ?? state.approvalStatus,
      sort: payload.sort ?? state.sort,
      page: payload.page ?? state.page,
    }),
    setActiveTab: (state, { payload }) => ({
      ...state,
      activeTab: payload,
      data: [],
      isLoaded: false,
      page: 1,
      search: '',
      network: '',
      programStatus: '',
      approvalStatus: '',
      sort: '',
      selectedRowKeys: [],
    }),
    setSelectedRowKeys: (state, { payload }) => ({
      ...state,
      selectedRowKeys: payload,
    }),
    setBulkActionLoading: (state, { payload }) => ({
      ...state,
      isBulkActionLoading: payload,
    }),
    setNetworks: (state, { payload }) => ({
      ...state,
      networks: payload,
    }),
    setGameGenres: (state, { payload }) => ({
      ...state,
      gameGenres: payload,
    }),
    setProgramDetail: (state, { payload }) => ({
      ...state,
      programDetail: payload,
      isProgramLoading: false,
    }),
    setProgramLoading: (state, { payload }) => ({
      ...state,
      isProgramLoading: payload,
    }),
    setProgramSaving: (state, { payload }) => ({
      ...state,
      isProgramSaving: payload,
    }),
    setGoalDetail: (state, { payload }) => ({
      ...state,
      goalDetail: payload,
      isGoalLoading: false,
    }),
    setGoalLoading: (state, { payload }) => ({
      ...state,
      isGoalLoading: payload,
    }),
    setGoalSaving: (state, { payload }) => ({
      ...state,
      isGoalSaving: payload,
    }),
    setFeatureSaving: (state, { payload }) => ({
      ...state,
      isFeatureSaving: payload,
    }),
    clearData: () => initialState,
  },
})

export default earnOffersManagementSlice
